import React from 'react';

export const InfoRow = ({ icon: Icon, label, value }: { icon?: any, label?: string | null, value?: React.ReactNode }) => {
    if (!label) return null;
    if (!value) return null;
  
    return (
      <>
        <div className="d-flex align-items-center mb-2">
          <div className="d-flex align-items-center" style={{ fontWeight: 'bold', color: 'var(--bs-primary)' }}>
            {Icon && <Icon size={18} className="me-2" />}
            <span className="fw-bold me-2" style ={{marginLeft: '5px'}}>{label}:</span>
          </div>
        </div>
        
        <div className="d-flex align-items-center mb-2">
          <div className="d-flex align-items-center" style={{ marginLeft: '40px' }}>
            <span>{value}</span>
          </div>
        </div>
      </>
    );
  };